import React, { useEffect, useRef, useState } from "react";
// import OtpInput from "react-otp-input";
import OtpInput from "react18-input-otp";

export default function OtpInputBox({
  otp,
  handleChange,
  clickCount,
  otpEnable,
}) {
  const otpRef = useRef();
  const [otpFocus, setOtpFocus] = useState(true);

  useEffect(() => {
    if (clickCount) {
      setOtpFocus(false);
      setTimeout(() => {
        setOtpFocus(true);
      });
    }
  }, [clickCount]);

  return (
    <>
      {otpFocus && (
        <OtpInput
          ref={otpRef}
          value={otp}
          onChange={handleChange}
          numInputs={6}
          shouldAutoFocus={true}
          isInputNum
          // isInputSecure={true}
          containerStyle="otp-input-block"
          inputStyle="otp-input-item"
          focusStyle="focus-none"
          data-testid="testid"
          isDisabled={otpEnable}
        />
      )}
    </>
  );
}
